<template>
<div class="content" id="content">

    <toolbar v-bind:selection="toolbar" v-bind:title="infoColmena.number+' en '+infoColmena.namecolmenar" action="archivar" />

    <div v-if="!loadingcolmena">
        <p>Colmena no encontrada</p>
        <a href="#/colmenares">Volver a colmenares</a>
    </div>


    <div v-if="infoColmena && loadingcolmena">

        <v-tabs>
            <v-tabs-slider color="orange"></v-tabs-slider>

            <v-tab @click="tabs.tab1 = false; tabs.tab2 = true;tabs.tab3 = false;tabs.tab4 = false;">Visitas ({{visits.length}})</v-tab>
            <v-tab @click="tabs.tab1 = true; tabs.tab2 = false;tabs.tab3 = false;tabs.tab4 = false;">Detalle</v-tab>
            <!--v-tab @click="tabs.tab1 = false; tabs.tab2 = true;tabs.tab3 = false">Estados ({{hive_states.length}})</v-tab-->

            <v-tab @click="tabs.tab1 = false; tabs.tab2 = false;tabs.tab3 = true; tabs.tab4 = false;">Varroa ({{varroas.length}})</v-tab>
            <v-tab @click="tabs.tab1 = false; tabs.tab2 = false;tabs.tab3 = false;  tabs.tab4 = true;">Alimentación ({{feed.length}})</v-tab>
        </v-tabs>

        <div v-if="tabs.tab1===true">
            <div class="card">

                <p class="title-box">{{ infoColmena.number }}</p>
                <p>{{ infoColmena.description }}</p>
                <p><b>Colmenar:</b> {{infoColmena.namecolmenar}}</p>
                <p><b>Inicio de la actividad:</b> {{ infoColmena.date_created.split("-").reverse().join('-') }}</p>
                <p>
                    <b>Núcleo:</b>&nbsp;
                    <span v-if="infoColmena.core === '1'">SI</span>
                    <span v-else>NO</span>
                </p>
                <p><b>Cuadros:</b> {{ infoColmena.number_frames }}</p>
                <p>
                    <b>Tipo:</b>&nbsp;
                    <span class="let">{{ infoColmena.type }}</span>
                </p>

                <p>
                    <b>Suelo:</b>&nbsp;
                    <span v-if="infoColmena.floor === 'antivarroa'">Suelo antivarroa</span>
                    <span v-if="infoColmena.floor === 'solido'">Suelo sólido</span>
                    <span v-if="infoColmena.floor === 'otro'">Otro</span>
                </p>

                <p>
                    <b>Origen:</b>&nbsp;
                    <span v-if="infoColmena.origin === 'propia'">Producción propia</span>
                    <span v-if="infoColmena.origin === 'compra'">Comprada</span>
                    <span v-if="infoColmena.origin === 'otro'">Otro</span>
                </p>


                <p>
                    <b>Alzas:</b>&nbsp;
                    <span v-if="infoColmena.alza === '1'">{{infoColmena.alza_value}}</span>
                    <span v-else>NO</span>
                </p>

                <p v-if="infoColmena.cheerup"><b>Agresividad</b>&nbsp;
                    <span class="let badge " v-bind:class="{'badge-rojo': infoColmena.cheerup === 'alta',
                                           'badge-amarillo': infoColmena.cheerup === 'media',
                                    'badge-verde': infoColmena.cheerup !== 'alta'
                                    }"

                          style="text-align:center;">{{ infoColmena.cheerup }}</span>
                </p>
                <p v-if="visits.length>0"><vigor v-bind:vigor="visits[0]['vigor']" ></vigor></p>



            </div>
            <div class="card">
                <div class="vsm-header">
                    <v-icon>mdi-bell-alert-outline</v-icon> AVISOS <span style="font-size:0.88rem;"></span>
                </div>


                <div v-if="infoColmena.tasks==='0'">Tareas: 0</div>
                <div v-else>

                    <div class="info-item">

                        <div class="info-item-list-left text-red " style="vertical-align: middle">
                           <b>Tareas:</b> {{ infoColmena.tasks }}
                        </div>

                        <div class="info-item-list-right">
                            <a v-bind:href="'#/tareas-colmena/' + infoColmena.id">
                                <v-icon color="grey">mdi-chevron-right</v-icon>
                            </a>

                        </div>
                    </div>

                </div>

                <div v-if="visits.length>0">
                    <div v-if="visits[0].return>0" class="text-red">
                        <hr>
                        Volver pronto.
                    <br/>
                        <b>{{visits[0].date.split("-").reverse().join('-')}}</b> - {{visits[0].return_description}}
                    </div>
                </div>

            </div>




            <div class="card">
                <div class="vsm-header">
                    <v-icon color="">mdi-crown-outline</v-icon> REINA <span style="font-size:0.88rem;"></span>
                </div>

                <div v-if="infoColmena.idqueen!=null">
                    <p class="title-box">
                        <span v-bind:class="'badge badge-'+infoColmena.color">{{ infoColmena.year }}</span>
                        {{ infoColmena.namequeen }}</p>

                    <span class="badge">{{ infoColmena.date }}</span>

                    <p>Estado: {{ infoColmena.state }}</p>
                    <p>Ciclo: {{ infoColmena.cycle }}</p>

                    <div><a v-bind:href="'#/queen-detalle/'+infoColmena.idqueen">VER DETALLE REINA</a></div>
                </div>
                <div v-else>
                    Sin reina
                </div>


            </div>

        </div>



        <div v-if="tabs.tab2===true">

            <div>

                <a v-bind:href="'#/visita-colmena-nueva/'+infoColmena.id" class="btn btn-yellow">
                    NUEVA VISITA
                </a>
                <br/><br/>

                <div v-if="visits.length>0" >

                    <span v-if="visits[0].return>0" class="text-red">Debes volver pronto: {{ visits[0].return_description }}<br/></span><br/>

                    <div v-for="visita in visits" :key="visita.id">

                        <div v-bind:class="'card border-bottom-color-'+visita.vigor">

                            <div class="info-item">
                                <div class="info-item-list-left" >

                                    <span class="text-success">{{ visita.date }}</span><br/>

                                    <p><b>Cuadros de cría que se quedaron: </b> {{ visita.frame_number_final }}</p>

                                    
                                    <p><b>Cuadros con cría al iniciar la visita: </b> {{ visita.frame_with_bee_number }}, <span style="text-transform: capitalize;">{{ visita.frame_with_bee_size }}</span></p>

                                    


                                    <span class="let badge " v-bind:class="{'badge-rojo': visita.cheerup === 'alta',
                                           'badge-amarillo': visita.cheerup === 'media',
                                    'badge-verde': visita.cheerup !== 'alta'
                                    }"

                                          style="text-align:center;">{{ visita.cheerup }}</span>
                                    &nbsp;<span style="padding-right:5px;">Agresividad</span>
                                    <p><vigor v-bind:vigor="visita.vigor" ></vigor></p>

                                    <p v-if="visita.unstretched_sheets!=null"><b>Láminas sin estirar</b>: {{visita.unstretched_sheets}}</p>

                                    <p v-if="visita.cria_eggs==='1'"><b>Cría huevos</b>: SI</p>

                                    <p v-if="visita.queen_royal==='1'"><b>Reina realera</b>: SI - <span style="text-transform: capitalize;">{{visita.queen_royal_value}}</span></p>
                                    <p v-if="visita.queen_view==='1'"><b>Reina vista</b>: SI <span v-if="visita.queen_view_info">- {{visita.queen_view_info}}</span></p>


                                    <p v-if="visita.drone_cells==='1'"><b>Zánganos celda</b>: SI <span v-if="visita.drone_cells_info">- {{visita.drone_cells_info}}</span></p>
                                    <p v-if="visita.drone==='1'"><b>Zánganos</b>: SI <span v-if="visita.drone_info">- {{visita.drone_info}}</span></p>


                                    <p v-if="visita.propolis==='1'"><b>Propóleo</b>: SI <span v-if="visita.propolis_info">- {{visita.propolis_info}}</span></p>
                                    <p v-if="visita.collect_pollen==='1'"><b>Recolección polen</b>: SI<span v-if="visita.collect_pollen_info">- {{visita.collect_pollen_info}}</span></p>


                                    <p v-if="visita.notes"><b>Notas visita</b>: {{visita.notes}}</p>


                                    <p v-if="visita.description!=null"><b>Descripción</b>:{{visita.description}}</p>




                                </div>

                                <div class="info-item-list-right">
                                    <a v-bind:href="'#/visita-colmena-editar/' + visita.id">
                                        <v-icon color="grey">mdi-chevron-right</v-icon>
                                    </a>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>
                <div v-else>
                    <div class="card">
                        No hay visitas.
                    </div>

                </div>

            </div>


        </div>

        <div v-if="tabs.tab3===true">

            <div v-if="varroas.length>0" >

                <div class="card" v-for="varroa in varroas" :key="varroa.id">

                    <div class="info-item">
                        <div class="info-item-list-left" >

                            <span class="text-success">{{ varroa.date.split("-").reverse().join('-') }}</span>
                            &nbsp;<span style="padding-right:5px;">Número: {{ varroa.number }}</span>
                            <p>{{varroa.description}}</p>

                        </div>

                        <div class="info-item-list-right">
                            <a v-bind:href="'#/varroa-editar/' + varroa.id">
                                <v-icon color="grey">mdi-chevron-right</v-icon>
                            </a>
                        </div>

                    </div>

                </div>
            </div>



            <div v-else>

                <div class="card">
                    No hay test de varroas.
                </div>

            </div>

        </div>

        <div v-if="tabs.tab4===true">
            <div>


                <div v-if="feed.length>0" >


                    <div v-for="visita in feed" :key="visita.id">

                        <div class="card">

                                <p class="text-success">{{ visita.date.split("-").reverse().join('-') }}</p>
                                <p>{{ visita.food }}, {{ visita.amount }}{{ visita.amount_decimal }} {{ visita.measure }}</p>

                        </div>
                    </div>

                </div>
                <div v-else>
                    <div class="card">
                        No se ha alimentado a esta colmena.
                    </div>

                </div>

            </div>

        </div>
    </div>

    <menubottom active="1" />
</div>

</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import menubottom from "@/components/MenuBottom"
import vigor from "@/components/hive_state/vigor"


import axios from "axios";
//const API = "https://appws.panimiel.com/new/index.php/api/";

export default {

  name: 'colmena',
  components: {toolbar,menubottom,vigor},
    data() {
      return {

        agree:'',
        dialog:false,
        tabs: {
            tab1: false,
            tab2: true,
            tab3: false,
            tab4: false,
        },
        toolbar: {
            return: '1',
            icons: [

              { text: 'Editar colmena', href:'colmena-editar/'+this.$route.params.id },
              { text: 'Archivar colmena', click:'delete', id:this.$route.params.id, method:'colmena' },
              { text: 'Nueva visita', href:'visita-colmena-nueva/'+this.$route.params.id },
              { text: 'Cancelar', href:'queens' }
            ],
          },
        infoColmena: null,
        visits: null,
        varroas: null,
        feed: null,

        loadingcolmena: false,
        loadingvisitas: false
      }
    },


  created() {

  auth.getUserLogged();
        this.getTodos();

  },methods:{

    async getTodos() {
        var that = this
       await axios.get("https://appws.panimiel.com/new/index.php/api/colmena/detail/"+this.$route.params.id).then((infoColmena) => {
          that.infoColmena = infoColmena.data
          that.loadingcolmena = true

        }).catch(() => {
            that.loadingcolmena = false
        })

        await axios.get("https://appws.panimiel.com/new/index.php/api/hive_visits/"+this.$route.params.id).then((visits) => {
          that.visits = visits.data
          that.loadingvisitas = true

        }).catch(() => {
            that.loadingvisitas = false
        })

        await axios.get("https://appws.panimiel.com/new/index.php/api/hive_varroa/"+this.$route.params.id).then((varroas) => {
          that.varroas = varroas.data
        })

        await axios.get("https://appws.panimiel.com/new/index.php/api/hive_feed/hive/"+this.$route.params.id).then((feed) => {
          that.feed = feed.data
        })

},
  /*   agreeElement(id) {
        var that = this
        that.agree = id
        that.dialog = true
    },
    deleteElement(id) {

        var that = this
        id = that.agree

        that.dialog = ''
        axios.delete('https://appws.panimiel.com/new/index.php/api/hive_state/'+id)
          .then(resp => {

          that.hive_states.length = (that.hive_states.length - 1)
          var x = document.getElementById("hive-state-"+id);
          x.style.display = "none";
        })
        that.dialog = ''

    }
    */
  }
};

</script>